import React, { useEffect } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetTableByIdQuery } from "../slices/tableSlice";
import Loader from "../components/Loader";
import Message from "../components/Message";

const TableOrderDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const outletId = userInfo?.outletsDetails?.[0]?._id;
  const floor = userInfo?.tableDetails?.floor;
  const tableNumber = userInfo?.tableDetails?.tableNumber;

  // console.log("Outlet ID:", outletId);
  // console.log("Floor:", floor);
  // console.log("Table Number:", tableNumber);

  const {
    data: orderDetails,
    isLoading,
    refetch,
    error,
  } = useGetTableByIdQuery({
    outletId: outletId,
    floor: floor,
    tableNumber: tableNumber,
    token: userInfo?.token,
  });

  useEffect(() => {
    if (error !== undefined)
      navigate("/login", { state: { redirectTo: "/tableOrderDetails" } });
  }, [error, navigate]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <>
      &nbsp;
      <h5 style={{ color: "black" }}>Table OrderDetails Screen</h5>
      <Row>
        <Col md={9}>
          {isLoading ? (
            <Loader />
          ) : error ? (
            <Message>{error?.data?.error}</Message>
          ) : (
            <div style={{ height: "100vh" }} className="tableContainer">
              <Table
                striped
                bordered
                hover
                responsive="md"
                className="table-custom"
              >
                <thead className={`${userInfo.themeColor}ThemeThead`}>
                  <tr>
                    <th>#</th>
                    <th>Mobile Number</th>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>GST</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {orderDetails?.currentOrderId?.map((order, orderIndex) => {
                    const items = order?.orderDetails || [];

                    const totalQuantity = items.reduce(
                      (sum, item) => sum + item.itemQuantity,
                      0
                    );
                    const totalPrice = items.reduce(
                      (sum, item) => sum + item.sellingPrice,
                      0
                    );
                    const totalGSTAmount = items.reduce(
                      (sum, item) => sum + (item.gstAmount ?? 0),
                      0
                    );
                    const totalAmount = totalPrice + totalGSTAmount;

                    const itemNames = items.map((item, index) => (
                      <div key={index}>
                        {item.itemName} - {item.itemQuantity}
                      </div>
                    ));

                    // Assuming all items have same gstTax, else this needs adjustment
                    const gstTax = items[0]?.gstTax || 0;

                    return (
                      <tr key={order._id}>
                        <td>{orderIndex + 1}</td>
                        <td>{order.mobileNumber}</td>
                        <td>{itemNames}</td>
                        <td>{totalQuantity}</td>
                        <td>{totalPrice.toFixed(2)}</td>
                        <td>
                          <div>
                            <span>{totalGSTAmount.toFixed(2)}</span>
                            <br />
                            <span>{gstTax.toFixed(0)}%</span>
                          </div>
                        </td>
                        <td>{totalAmount.toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};
export default TableOrderDetailsScreen;
